const path = '/img/activity/index';

export const BANNER_INFO: BasicInfo = {
  title: 'StreamLake活动资讯',
  description: '',
  image: `${path}/banner.webp`,
};

export const BANNER_INFO_MOBILE: BasicInfo = {
  title: '活动资讯',
  description: '',
  image: `${path}/banner-mobile.webp`,
};

export const ACTIVITY_SUMMARIES: {
  title: string;
  contents: SummaryInfo[];
} = {
  title: '热门活动',
  contents: [
    {
      title: 'StreamLake品牌发布会',
      description: '云启共生 · 水润万象',
      image: `${path}/publish.webp`,
      timestamp: '2022/08/10',
      location: '中国·北京',
      summary: [
        {
          label: '包容力',
          content: '云启共生·水润万象',
        },
        {
          label: '生命力',
          content: '把视频“重工业”变成“轻工业”',
        },
        {
          label: '创造力',
          content: '视频AI，无处不在',
        },
        {
          label: '芯动力',
          content: 'NVDIA 澎湃算力赋能视频处理和 AI 计算',
        },
        {
          label: '凝聚力',
          content: '圆桌论坛：如何为视频化转型客户创造价值',
        },
      ],
      primaryLink: {
        title: '查看回放',
        url: '/activity/publish',
      },
      minorLink: {
        title: '活动资讯',
        url: '/content/activity/publish',
      },
    },
    {
      title: '2022北京 LiveVideoStackCon大会',
      description: 'StreamLake音视频技术创新与应用',
      image: `${path}/lvs.webp`,
      timestamp: '2023/04/01',
      location: '中国·北京',
      summary: [
        {
          label: '亮点一',
          content: '为什么要做算法产品化',
        },
        {
          label: '亮点二',
          content: '快手智能处理与编码算法产品化方案',
        },
        {
          label: '亮点三',
          content: 'StreamLake转码产品介绍及其应用',
        },
      ],
      primaryLink: {
        title: '活动回顾',
        url: '/activity/lvs',
      },
      minorLink: {
        title: '活动资讯',
        url: '/content/activity/lvs',
      },
    },
  ],
};

export const LATEST_NEWS = {
  title: '最新动态',
  contents: [
    // get contents from kconf
  ],
};
